import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementSelect, SearchFacets } from '@uncinc/react-searchkit';

import { facetAttributes } from '../config';

const MetaSearchFacets: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SearchFacets className="MetaSearch__Facets">
      {facetAttributes.map((facetAttribute) => {
        const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

        return (
          <SearchFacetRefinementSelect
            key={attribute}
            className="Select__inner"
            attribute={attribute}
            // @ts-expect-error
            // Title is a prop from @uncinc/uncinc-react-kitchen-sink's FormSelect component
            // used within SearchFacetRefinementSelect, which, as of yet, has no typing.
            // So we expect a Typescript error here.
            title={t(`searchkit.facets.${attribute}.label`)}
            placeholder={t(`searchkit.facets.${attribute}.placeholder`)}
          />
        );
      })}
    </SearchFacets>
  );
};

export default MetaSearchFacets;
